module.exports = __webpack_public_path__ + "img/img3.11e74f80.jpg";